import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../../components/layout/PageLayout';
import HelmetWrapper from '../../components/common/HelmetWrapper';
import DeadlyCrossingNav from './DeadlyCrossingNav';

/**
 * Public support page for Deadly Crossing (App Store / Google Play contact URL).
 */
const DeadlyCrossingSupportPage = () => {
  return (
    <PageLayout>
      <HelmetWrapper>
        <title>Deadly Crossing — Support</title>
        <meta
          name="description"
          content="Support for Deadly Crossing by Zok Labs. Email omerwaqaskhan@gmail.com for help with the game, ads, or save data."
        />
        <meta name="robots" content="noindex,follow" />
      </HelmetWrapper>

      <div className="bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-sm border p-8">
            <DeadlyCrossingNav />
            <h1 className="text-3xl font-bold text-gray-900 mb-6">Deadly Crossing — Support</h1>

            <p className="text-gray-700 text-lg mb-4">
              Need help with the game, ads, or your save data?
            </p>
            <p className="text-gray-700 mb-2">
              Email:{' '}
              <a
                href="mailto:omerwaqaskhan@gmail.com"
                className="text-emerald-600 hover:text-emerald-800 hover:underline font-medium"
              >
                omerwaqaskhan@gmail.com
              </a>
            </p>
            <p className="text-gray-700 mb-8">
              Please include your device model and OS version (iOS or Android).
            </p>

            <p className="text-gray-700">
              <Link
                to="/deadly-crossing/privacy"
                className="text-emerald-600 hover:text-emerald-800 hover:underline"
              >
                Privacy Policy
              </Link>
              <span className="text-gray-400 mx-2">·</span>
              <Link
                to="/deadly-crossing"
                className="text-emerald-600 hover:text-emerald-800 hover:underline"
              >
                Deadly Crossing home
              </Link>
            </p>

            <p className="mt-10 text-sm text-gray-500">Publisher: Zok Labs · Last updated: August 2026</p>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default DeadlyCrossingSupportPage;
